import React from "react";

const ArticleNavigationTab = ({
    article,
    isNext
}) => {
    const { aImg, label, url } = article;

    const renderArticleImage = () => {
        if(aImg){
            return <picture>
                {
                    aImg.sourceTagData.map((data, index) => {
                        return (
                            <source key={index} media={data.media} srcSet={data.srcset} type={data.type} />
                        );
                    })
                }
                <img className={aImg.imageTagData.class} src={aImg.imageTagData.src} alt={aImg.imageTagData.alt} title={aImg.imageTagData.title}></img>
            </picture>;
        } else {
            return <div className="missingImage">
                <i className="far fa-image" aria-hidden="true" />
            </div>;
        }
    };

    return (
        <div className={`${isNext ? "nextArticle" : "previousArticle"}`}>
            <div className="ArticleNavigationTab">
                <a href={url}>
                    <span className="ArticleNavigationTabContent">
                        {renderArticleImage()}
                        <p className="label">{label}</p>
                    </span>
                    <span className="ArticleNavigationTabArrows">
                        {isNext ? <i className='far fa-chevron-square-right'></i> : <i className='far fa-chevron-square-left'></i>}
                    </span>
                </a>
            </div>
            {isNext ? <a href={url}><p className="next">Next Article</p></a> : <a href={url}><p className="previous">Previous Article</p></a>}
        </div>
    );
};

export default ArticleNavigationTab;